import config from "config";
import { useState } from "react";
import { Input, Button } from 'reactstrap'
import { getExamType } from "utils/common";
import styles from 'components/Registration/Form/signupStyles.module.css'
import CouponIcon from '../../assets/mdi_coupon.svg'
import AppliedShower from '../../assets/coupouapplied_shower.svg'

export default function ApplyCoupon({
    partialData,
    setRemoveCoupon,
    setCouponCode,
    setCoupon,
}) {
    const [localCouponCode, setLocalCouponCode] = useState('')
    const [appliedCoupon, setAppliedCoupon] = useState(null)
    const [message, setMessage] = useState('')

    const handleCouponVerification = async () => {
        if (!localCouponCode) {
            setMessage('Please enter a coupon code.')
            return
        }

        const url = config.VALIDATE_COUPON_API

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    exam_type: getExamType(),
                    coupon_code: localCouponCode,
                    class_stream: partialData.data.class_stream,
                    lead_term: partialData.data.lead_term,
                }),
            })

            const result = await response.json()
            setRemoveCoupon(result.data.exam_discount_amount)

            if (result.success) {
                setAppliedCoupon(localCouponCode)
                setCouponCode(localCouponCode) // ✅ Now using prop function
                setCoupon(localCouponCode)
                setMessage(
                    `Success: ${result.message || 'Coupon Applied Successfully'}`,
                )
            } else {
                setMessage(`Error: ${result.message || 'Invalid Coupon'}`)
            }
        } catch (error) {
            setMessage('Invalid Coupon')
        }
    }

    const handleRemoveCoupon = () => {
        setAppliedCoupon(null)
        setLocalCouponCode('')
        setMessage('')
        setRemoveCoupon(0)
        setCouponCode('') // ✅ Reset parent state
        setCoupon('')
    }

    return (
        <div className={`bg-white ${styles.couponbox}`}>
            <div className={`${styles.apply_coupon_wrapper}`}>
                <h4>
                    <img src={CouponIcon} alt="coupon" /> Apply coupon
                </h4>
                {!appliedCoupon ? (
                    <div className={`d-flex gap-2 ${styles.applycoupon_input}`}>
                        <Input
                            placeholder="Enter coupon code"
                            value={localCouponCode}
                            onChange={(e) => setLocalCouponCode(e.target.value)}
                        />
                        <Button
                            className={`${styles.applycouponbtn}`}
                            onClick={handleCouponVerification}
                        >
                            Apply
                        </Button>
                    </div>
                ) : (
                    <div className={`${styles.appliedconpoun_cong}`}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h3>
                                    <strong>Congratulations</strong>
                                </h3>
                                <div className={`${styles.coponcode}`}>
                                    Coupon '<strong>{appliedCoupon}</strong>'
                                    applied.
                                </div>
                                <Button
                                    className={`${styles.couponremove}`}
                                    onClick={handleRemoveCoupon}
                                >
                                    Remove
                                </Button>
                            </div>
                            <div>
                                <img src={AppliedShower} alt="" />
                            </div>
                        </div>
                    </div>
                )}
                {message && !appliedCoupon && (
                    <div className="text-danger text-error-red mt-2 font-size-xs">
                        {message}
                    </div>
                )}
            </div>
        </div>
    )
}
